import { TimeRange } from 'types'

import { getEndOfDay } from './getEndOfDay'
import { getStartOfDay } from './getStartOfDay'

export const extendRangeToUtcDayLimits = ({ from, to }: TimeRange<Date | number>) => ({
  from: getStartOfDay(from),
  to: getEndOfDay(to),
})
